import {t} from "i18next";
import type {InitResponse, PaginatedResponse, ThreadInfo} from "../../types";
import {parseApiDate} from "../../utils/dateUtils";

export const UNKNOWN_THREAD_DATE = new Date(0).toISOString();

function normalizeName(name: unknown): string {
    const trimmed = typeof name === "string" ? name.trim() : "";
    return trimmed || t("common.defaultThreadTitle");
}

function normalizeDate(lastUpdated: string): string {
    const time = parseApiDate(lastUpdated).getTime();
    return Number.isNaN(time) || time <= 0 ? UNKNOWN_THREAD_DATE : lastUpdated;
}

export function normalizeThreadInfo(thread: ThreadInfo): ThreadInfo {
    return {
        ...thread,
        name: normalizeName(thread.name),
        lastUpdated: normalizeDate(thread.lastUpdated),
    };
}

export function normalizeThreadSearchResult<
    T extends {threadName: string; lastUpdated: string},
>(result: T): T {
    return {
        ...result,
        threadName: normalizeName(result.threadName),
        lastUpdated: normalizeDate(result.lastUpdated),
    };
}

export function normalizeThreadPage(
    page: PaginatedResponse<ThreadInfo>
): PaginatedResponse<ThreadInfo> {
    return {...page, items: (page.items ?? []).map(normalizeThreadInfo)};
}

export function normalizeInitResponse(init: InitResponse): InitResponse {
    return {
        ...init,
        threads: init.threads ? normalizeThreadPage(init.threads) : init.threads,
    };
}
